module.exports = __webpack_public_path__ + "img/27.7e943ee2.png";